import { isEmpty } from 'lodash'
import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { ICancelTripsForm } from 'features/Trips/types'
import { CANCELLATION_CATEGORY_MAP } from 'features/Trips/utils'
import { GTCancellationCategory } from 'gql/types.generated'

const categoryMessages = defineMessages({
  required: {
    id: 'trips.cancelTrips.category.required',
    defaultMessage: 'The category is required'
  }
})

const subcategoryMessages = defineMessages({
  required: {
    id: 'trips.cancelTrips.subcategory.required',
    defaultMessage: 'The subcategory is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ICancelTripsForm> => {
  return yup.object().shape({
    category: yup.mixed().required(intl.formatMessage(categoryMessages.required)),
    subcategory: yup.mixed().when(['category'], {
      is: (category: GTCancellationCategory | ''): boolean => {
        return Boolean(category) && !isEmpty(CANCELLATION_CATEGORY_MAP[category as GTCancellationCategory])
      },
      then: yup.mixed().required(intl.formatMessage(subcategoryMessages.required))
    }),
    comments: yup.string()
  })
}
